import {
    CoreApiFilterObject,
    FILTER_TYPES,
} from '@/coreApi/filters/coreApiFilterObject'

const FILTER_ID_PAGE_FILTER = 'pf'

const coreApiPageFilters = [
    {
        title: 'Referrers',
        key: 'r',
        field_name: 'referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Home',
                value: 'site_internal_home',
            },
            {
                label: 'Internal',
                value: 'site_internal',
            },
            {
                label: 'Infinite Scroll',
                value: 'site_internal_infinite_scroll',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Hurriyet',
                value: 'hurriyet',
            },
            {
                label: 'Milliyet',
                value: 'milliyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'Source Referrers',
        key: 'ord',
        field_name: 'origin_referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Milliyet',
                value: 'milliyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'UTM Referrers',
        key: 'ur',
        field_name: 'referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'f5haber',
            'facebook',
            'haberler.com',
            'gazetekeyfi',
            'gazeteoku',
            'google',
            'guncelhaberler',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'UTM Source Referrers',
        key: 'usr',
        field_name: 'origin_referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'f5haber',
            'facebook',
            'haberler.com',
            'gazetekeyfi',
            'gazeteoku',
            'google',
            'guncelhaberler',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'Devices',
        key: 'd',
        field_name: 'device',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Desktop',
                value: 'desktop',
            },
            {
                label: 'Mobile',
                value: 'mobile',
            },
            {
                label: 'Tablet',
                value: 'tablet',
            },
        ],
    },
    {
        title: 'Sources',
        key: 's',
        field_name: 'source',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Web',
                value: 'web',
            },
            {
                label: 'Amp',
                value: 'amp',
            },
            {
                label: 'Instance Article',
                value: 'ia',
            },
            {
                label: 'Android App',
                value: 'androidApp',
            },
            {
                label: 'IOS App',
                value: 'iosApp',
            },
        ],
    },
    {
        title: 'Domains',
        key: 'ds',
        field_name: 'page_domains',
        filter_type: 'checkbox',
        data: [
            {
                label: 'tr.ign.com',
                value: 'tr.ign.com',
            },
        ],
    },
    {
        title: 'Categories',
        key: 'c',
        field_name: 'breadcrumb_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Gündem', value: 'gündem' },
            { label: 'Ekonomi', value: 'ekonomi' },
            { label: 'Kelebek', value: 'kelebek' },
            { label: 'Yaşam', value: 'yaşam' },
            { label: 'Dünya', value: 'dünya' },
            { label: 'Spor', value: 'spor' },
            { label: 'Yazarlar', value: 'yazarlar' },
            { label: 'Cumartesi', value: 'cumartesi' },
            { label: 'Pazar', value: 'pazar' },
            { label: 'Seyahat', value: 'seyahat' },
            { label: 'Eğitim', value: 'eğitim' },
            { label: 'Astroloji', value: 'astroloji' },
            { label: 'Bigpara', value: 'bigpara' },
        ],
    },
    {
        title: 'Authors',
        key: 'a',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Billur Dalak', value: 'billur dalak' },
            { label: 'Emre Özdemir', value: 'emre özdemir' },
            { label: 'Yusuf Canpolat', value: 'yusuf canpolat' },
            { label: 'Baran Köse', value: 'baran köse' },
            { label: 'Ata Biricik', value: 'ata biricik' },
            { label: 'Burçin Aygün', value: 'burçin aygün' },
            { label: 'Rosie Knight', value: 'rosie knight' },
            { label: 'Bahadır Yaramış', value: 'bahadır yaramış' },
        ],
    },
    {
        title: 'Editors',
        key: 'ed',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Billur Dalak', value: 'billur dalak' },
            { label: 'Emre Özdemir', value: 'emre özdemir' },
            { label: 'Yusuf Canpolat', value: 'yusuf canpolat' },
            { label: 'Baran Köse', value: 'baran köse' },
            { label: 'Ata Biricik', value: 'ata biricik' },
            { label: 'Burçin Aygün', value: 'burçin aygün' },
            { label: 'Rosie Knight', value: 'rosie knight' },
            { label: 'Bahadır Yaramış', value: 'bahadır yaramış' },
        ],
    },
    {
        title: 'User Type',
        key: 'ut',
        field_name: 'user_types',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Anonymous',
                value: 'anonymous',
            },
            {
                label: 'Paid',
                value: 'paid',
            },
            {
                label: 'Logged In',
                value: 'loggedin',
            },
        ],
    },
    {
        title: 'Keywords',
        key: 'kw',
        field_name: 'keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Keywords Exclude',
        key: 'kwn',
        field_name: 'not_keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Search',
        key: 'srch',
        field_name: 'search_include',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            '404 hata sayfası',
        ],
    },
]

export const coreApiPageFilterIgnObject = new CoreApiFilterObject(FILTER_ID_PAGE_FILTER, FILTER_TYPES.VALUES, coreApiPageFilters)
